import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { workingHoursFrequency } from 'modules/contracts/lib/frequencies'

import Item from './Item'

interface Props {
  workingHours?: number
  frequency?: string
}

const WorkingHours = ({ workingHours, frequency }: Props) => {
  const hasWorkSchedule = workingHours && frequency
  const description = hasWorkSchedule
    ? i18n.t('contract_versions.time.working_hours.description', {
        hours: workingHours,
        frequency: workingHoursFrequency(frequency || ''),
      })
    : undefined

  return (
    <Item
      id="working_hours"
      title={i18n.t('contract_versions.time.working_hours.title')}
      description={description}
    />
  )
}

export default observer(WorkingHours)
